export default __webpack_public_path__ + "static/media/05.08a75c3e.jpg";